import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { MobileRequestBookingDialogComponent } from './mobile-request-booking-dialog.component';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Injectable()
export class MobileRequestBookingDialogService {
  constructor(private dialog: MatDialog) {}
  dialogRef: MatDialogRef<any>;
  public open(vessel: Vessel): Observable<any> {
    this.dialogRef = this.dialog.open(MobileRequestBookingDialogComponent, {
      width: '100vh',
      height: '100vh',
      maxWidth: '100vh',
      maxHeight: '100vh',
      hasBackdrop: false,
    });
    this.dialogRef.componentInstance.vessel = vessel;

    return this.dialogRef.afterClosed();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
